var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/phone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1816_11753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5788 2.75C14.8858 2.82522 15.198 2.88346 15.4984 2.97907C16.2704 3.22512 16.9187 3.6818 17.5246 4.21807C19.7876 6.22193 21.8239 8.46165 23.9542 10.6029C24.8298 11.4827 25.3994 12.5441 25.5508 13.8054C25.7255 15.2604 25.2877 16.5416 24.393 17.6559C23.9423 18.2169 23.4223 18.7236 22.9105 19.2307C22.0803 20.0538 21.2309 20.8575 20.3577 21.6995C20.5477 22.1135 20.7339 22.5469 20.9435 22.9686C21.7413 24.5736 22.8279 25.9756 23.9475 27.3534C26.138 30.0484 28.6202 32.4191 31.4891 34.3594C32.316 34.9185 33.1592 35.447 34.0658 35.8668C34.2162 35.9362 34.2969 35.9182 34.4105 35.8018C35.4852 34.6996 36.5552 33.5926 37.6494 32.5113C38.4931 31.6771 39.4627 31.0345 40.6339 30.7836C42.175 30.4541 43.5415 30.8846 44.7112 31.9096C45.4503 32.557 46.1225 33.284 46.8157 33.9848C48.2528 35.4383 49.6827 36.8991 51.1184 38.3545C51.846 39.0922 52.4447 39.923 52.6414 40.9621C52.9503 42.5952 52.6027 44.1113 51.5729 45.4032C50.9656 46.1651 50.2375 46.8291 49.5576 47.5303C48.9785 48.1278 48.3593 48.6883 47.8112 49.3139C46.4199 50.9023 44.7374 51.9103 42.6386 52.1714C41.1509 52.3568 39.69 52.1903 38.2338 51.8986C35.3396 51.3187 32.6579 50.1632 30.0539 48.7917C23.6276 45.4061 18.1481 40.8398 13.5561 35.1607C11.0549 32.0673 8.85198 28.7759 7.12557 25.1695C6.08906 23.0045 5.15663 20.7969 4.59373 18.447C4.30822 17.258 4.15831 16.0568 4.16738 14.8265C4.17597 13.7389 4.20844 12.6698 4.55792 11.6254C5.00623 10.2864 5.6861 9.10081 6.69063 8.11611C8.00119 6.83148 9.30936 5.54443 10.6304 4.27097C11.4502 3.48185 12.3969 2.93151 13.5404 2.78785C13.5695 2.78397 13.5967 2.7631 13.6249 2.75C13.9429 2.75 14.2608 2.75 14.5788 2.75Z",
    fill: "#FCAF17"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1816_11753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.5833,
    height: 49.5,
    fill: "white",
    transform: "translate(4.16699 2.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonesvg);
export default __webpack_public_path__ + "static/media/phonesvg.157568744aa5f73f2d3e44bf2c076fb5.svg";
export { ForwardRef as ReactComponent };